function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { detectBusinessTypesApi, detectTemplatesApi, detectCreateTemplateApi, detectImportJsonApi, detectTemplateTreeApi, detectTemplateHistoryApi, detectRestoreTemplateApi, detectCloneTemplateApi, detectTemplateStatusApi } from '@/api/detection';
export default {
  name: 'DetectionTemplates',
  data: function data() {
    return {
      loading: false,
      saving: false,
      list: [],
      bizList: [],
      current: null,
      createVisible: false,
      createForm: {
        business_type_id: null,
        code: '',
        name: '',
        remark: ''
      },
      importVisible: false,
      importFile: null,
      treeVisible: false,
      treeLoading: false,
      treeTitle: '树预览',
      treeMeta: null,
      treeData: [],
      historyVisible: false,
      historyLoading: false,
      historyList: [],
      cloneVisible: false,
      cloneForm: {
        source_id: 0,
        code: '',
        name: '',
        business_type_id: 0
      }
    };
  },
  created: function created() {
    this.loadBiz();
    this.getList();
  },
  methods: {
    loadBiz: function loadBiz() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return detectBusinessTypesApi();
            case 2:
              res = _context.sent;
              _this.bizList = res.data || res || [];
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getList: function getList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.loading = true;
              _context2.prev = 1;
              _context2.next = 4;
              return detectTemplatesApi();
            case 4:
              res = _context2.sent;
              _this2.list = res.data || res || [];
            case 6:
              _context2.prev = 6;
              _this2.loading = false;
              return _context2.finish(6);
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1,, 6, 9]]);
      }))();
    },
    openCreate: function openCreate() {
      this.createForm = {
        business_type_id: this.bizList[0] && this.bizList[0].id || null,
        code: '',
        name: '',
        remark: ''
      };
      this.createVisible = true;
    },
    submitCreate: function submitCreate() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(!_this3.createForm.business_type_id || !_this3.createForm.code || !_this3.createForm.name)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", _this3.$message.warning('请填写完整'));
            case 2:
              _this3.saving = true;
              _context3.prev = 3;
              _context3.next = 6;
              return detectCreateTemplateApi(_this3.createForm);
            case 6:
              _this3.$message.success('已创建');
              _this3.createVisible = false;
              _this3.getList();
              _context3.next = 14;
              break;
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](3);
              _this3.$message.error(_context3.t0 && _context3.t0.message || '创建失败');
            case 14:
              _context3.prev = 14;
              _this3.saving = false;
              return _context3.finish(14);
            case 17:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[3, 11, 14, 17]]);
      }))();
    },
    openImport: function openImport(row) {
      var _this4 = this;
      this.current = row;
      this.importFile = null;
      this.importVisible = true;
      this.$nextTick(function () {
        if (_this4.$refs.uploader) _this4.$refs.uploader.clearFiles();
      });
    },
    onFileChange: function onFileChange(file) {
      this.importFile = file.raw || file;
    },
    submitImport: function submitImport() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var fd, res, data;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!_this5.importFile || !_this5.current)) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return", _this5.$message.warning('请选择 JSON 文件'));
            case 2:
              fd = new FormData();
              fd.append('template_id', _this5.current.id);
              fd.append('file', _this5.importFile);
              _this5.saving = true;
              _context4.prev = 6;
              _context4.next = 9;
              return detectImportJsonApi(fd);
            case 9:
              res = _context4.sent;
              data = res.data || res || {};
              _this5.$message.success("\u5BFC\u5165\u6210\u529F\uFF1A\u90E8\u4F4D ".concat(data.parts_count || 0, " / \u7F3A\u9677 ").concat(data.defects_count || 0));
              _this5.importVisible = false;
              _this5.getList();
              _context4.next = 19;
              break;
            case 16:
              _context4.prev = 16;
              _context4.t0 = _context4["catch"](6);
              _this5.$message.error(_context4.t0 && _context4.t0.message || '导入失败');
            case 19:
              _context4.prev = 19;
              _this5.saving = false;
              return _context4.finish(19);
            case 22:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[6, 16, 19, 22]]);
      }))();
    },
    openTree: function openTree(row) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res, data;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.treeTitle = "\u6811\u9884\u89C8 \xB7 ".concat(row.name);
              _this6.treeVisible = true;
              _this6.treeLoading = true;
              _this6.treeData = [];
              _this6.treeMeta = null;
              _context5.prev = 5;
              _context5.next = 8;
              return detectTemplateTreeApi(row.id);
            case 8:
              res = _context5.sent;
              data = res.data || res || {};
              _this6.treeMeta = data.template || null;
              _this6.treeData = data.tree || [];
              _context5.next = 17;
              break;
            case 14:
              _context5.prev = 14;
              _context5.t0 = _context5["catch"](5);
              _this6.$message.error(_context5.t0 && _context5.t0.message || '加载失败');
            case 17:
              _context5.prev = 17;
              _this6.treeLoading = false;
              return _context5.finish(17);
            case 20:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[5, 14, 17, 20]]);
      }))();
    },
    openHistory: function openHistory(row) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var res;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this7.current = row;
              _this7.historyVisible = true;
              _this7.historyLoading = true;
              _context6.prev = 3;
              _context6.next = 6;
              return detectTemplateHistoryApi(row.id);
            case 6:
              res = _context6.sent;
              _this7.historyList = res.data || res || [];
            case 8:
              _context6.prev = 8;
              _this7.historyLoading = false;
              return _context6.finish(8);
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[3,, 8, 11]]);
      }))();
    },
    restoreHistory: function restoreHistory(h) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this8.$confirm("\u786E\u8BA4\u8FD8\u539F\u5230\u5386\u53F2 #".concat(h.id, "\uFF1F\u5F53\u524D\u914D\u7F6E\u4F1A\u5148\u5199\u5165\u5386\u53F2\u3002"), '提示', {
                type: 'warning'
              });
            case 2:
              _context7.prev = 2;
              _context7.next = 5;
              return detectRestoreTemplateApi(_this8.current.id, h.id);
            case 5:
              _this8.$message.success('已还原');
              _this8.historyVisible = false;
              _this8.getList();
              _context7.next = 13;
              break;
            case 10:
              _context7.prev = 10;
              _context7.t0 = _context7["catch"](2);
              _this8.$message.error(_context7.t0 && _context7.t0.message || '还原失败');
            case 13:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[2, 10]]);
      }))();
    },
    openClone: function openClone(row) {
      this.cloneForm = {
        source_id: row.id,
        code: row.code + '_COPY',
        name: row.name + '_副本',
        business_type_id: row.business_type_id
      };
      this.cloneVisible = true;
    },
    submitClone: function submitClone() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this9.saving = true;
              _context8.prev = 1;
              _context8.next = 4;
              return detectCloneTemplateApi(_this9.cloneForm);
            case 4:
              _this9.$message.success('已克隆（默认停用）');
              _this9.cloneVisible = false;
              _this9.getList();
              _context8.next = 12;
              break;
            case 9:
              _context8.prev = 9;
              _context8.t0 = _context8["catch"](1);
              _this9.$message.error(_context8.t0 && _context8.t0.message || '克隆失败');
            case 12:
              _context8.prev = 12;
              _this9.saving = false;
              return _context8.finish(12);
            case 15:
            case "end":
              return _context8.stop();
          }
        }, _callee8, null, [[1, 9, 12, 15]]);
      }))();
    },
    onStatus: function onStatus(row) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return detectTemplateStatusApi(row.id, {
                status: row.status
              });
            case 3:
              _context9.next = 9;
              break;
            case 5:
              _context9.prev = 5;
              _context9.t0 = _context9["catch"](0);
              row.status = row.status === 1 ? 0 : 1;
              _this10.$message.error(_context9.t0 && _context9.t0.message || '状态更新失败');
            case 9:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[0, 5]]);
      }))();
    }
  }
};